import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2356b5d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column is-7" }
const _hoisted_2 = { class: "column" }
const _hoisted_3 = { class: "column" }
const _hoisted_4 = { class: "column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chronometer = _resolveComponent("Chronometer")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Box = _resolveComponent("Box")!

  return (_openBlock(), _createBlock(_component_Box, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "columns is-flex is-align-items-center clicable",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.triggeredTask && _ctx.triggeredTask(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.task.description ? _ctx.task.description : "Nenhuma descrição informada."), 1),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.task.project.name), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Chronometer, {
            "time-in-seconds": _ctx.task.timeInSeconds
          }, null, 8, ["time-in-seconds"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            name: 'delete',
            class: _normalizeClass('ml-2 is-danger'),
            icon: { name: 'fas fa-trash', class: 'is-small' },
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeTask(_ctx.task.id || '')))
          })
        ])
      ])
    ]),
    _: 1
  }))
}